import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { URL_SERVICIOS } from '../config/config';
import { Movimientopago } from '../models/movimientopgo';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class MovimientospgosService {

  constructor(
    public http: HttpClient
  ) { }


  crearmovimientospagos( movimientospgos: Movimientopago ) {
    let url = URL_SERVICIOS + '/movimiento';
    return this.http.post ( url , movimientospgos)
    .map (( resp: any ) => {
      return resp;
    });

  }



 

  devolucioneslicencias( numero_orden: string, cantidalicencias: string, idsmx: string, texto:string, identificadorpescador: string, observaciones?: string ) {
    let url = URL_SERVICIOS + '/movimiento/devolucioneslic/' + numero_orden + "/" + idsmx + "/" +  cantidalicencias + "/Return Licence(s)/" + identificadorpescador + "/" + observaciones;
    return this.http.get ( url )
    .map (( resp: any ) => {
      return resp;
    });

  }


  devolucioneslicenciasagencias( numero_orden: string, cantidalicencias: string, idsmx: string, texto:string, identificadorpescador: string, observaciones: string ) {
    let url = URL_SERVICIOS + '/movimiento/devolucioneslicagencia/' + numero_orden + "/" + idsmx + "/" +  cantidalicencias + "/Return Licence(s)/" + identificadorpescador + "/" + observaciones;
    return this.http.get ( url )
    .map (( resp: any ) => {
      return resp;
    });

  }


  crearmovimientospagosyprecompra( movimientospgos: Movimientopago ) {
    let url = URL_SERVICIOS + '/movimiento/solicitudlicencias';
    return this.http.post ( url , movimientospgos)
    .map (( resp: any ) => {
      return resp;
    });

  }


  crearmovimientospagosyprecompraagencia( movimientospgos: Movimientopago ) {
    let url = URL_SERVICIOS + '/movimiento/solicitudlicenciasagencias';
    return this.http.post ( url , movimientospgos)
    .map (( resp: any ) => {
      return resp;
    });

  }


  jsonexcelverifica( nombreArchivo: string, cantidadsolicitada: number, nombrebarco: string, fechapescainicial: any ) {
    let url = environment.rutaverificaxls+nombreArchivo + "/" + cantidadsolicitada + "/" + nombrebarco+ "/" + fechapescainicial;
    // console.log (url);
     return this.http.get ( url)
     .map (( resp: any ) => {
       return resp;
     });
  }


   jsonexcelverificastatus( nombreArchivo: string, cantidadsolicitada: number, nombrebarco: string, fechapescainicial: any ) {
    let url = environment.rutaverificaxls+nombreArchivo + "/" + cantidadsolicitada + "/" + nombrebarco+ "/" + fechapescainicial +"/day";
    // console.log (url);
     return this. http.get ( url)
     .map (( resp: any ) => {
       return resp;
     });
  }



  jsonexcelverificalanding( nombreArchivo: string, cantidadsolicitada: number,  fechapescainicial: any ) {
    let url = environment.rutaverificaxlsporevento+nombreArchivo + "/" + cantidadsolicitada + "/"  + fechapescainicial;
    // console.log (url);
     return this.http.get ( url)
     .map (( resp: any ) => {
       return resp;
     });
  }


  jsonexcelverificaagenciaxevento( nombreArchivo: string, cantidadsolicitada: number,  fechapescainicial: any ) {
    let url = environment.rutaverificaxls_agenciaxevento+nombreArchivo + "/" + cantidadsolicitada + "/"  + fechapescainicial;
    // console.log (url);
     return this.http.get ( url)
     .map (( resp: any ) => {
       return resp;
     });
  }


  jsonexcelverificaagencia( nombreArchivo: string, cantidadsolicitada: number, nombrebarco: string, fechapescainicial: any, tipolicenciaselecc : string ) {
    let url = environment.rutaverificaxls+nombreArchivo + "/" + cantidadsolicitada + "/" + nombrebarco+ "/" + fechapescainicial + "/" + tipolicenciaselecc;
    // console.log (url);
     return this.http.get ( url)
     .map (( resp: any ) => {
       return resp;
     });
  }



  
 

  jsonexcelverificaagenciaprepago( nombreArchivo: string, cantidadsolicitada: number, nombrebarco: string, fechapescainicial: any, tipolicenciaselecc : string ) {
    let url = environment.rutaverificaxlsagencia+nombreArchivo + "/" + cantidadsolicitada + "/" + nombrebarco+ "/" + fechapescainicial + "/" + tipolicenciaselecc;
    // console.log (url);

    // "http://localhost:3000/upload/verificaxlsagencia/230527_014_Pez Feliz1_dylan.xlsx/4/dylan/2023-05-27/Day"

     return this.http.get ( url)
     .map (( resp: any ) => {
       return resp;
     });
  }


  listamovimiento( idempresa: string ) {
    let url = URL_SERVICIOS + '/movimiento/' + idempresa;
    return this.http.get ( url )
    .map (( resp: any ) => {
       return (resp);
    });

  }
  


  static descargarchivoXlS (path: string, filename: string, goBlank = false) {
    const downloadIntance = document.createElement('a');
    downloadIntance.href= path;
    downloadIntance.target = goBlank ? '_blanck' : null;
    downloadIntance.download=filename;
    
    document.body.appendChild(downloadIntance);
    downloadIntance.click();
    document.body.removeChild(downloadIntance);

  }


  listamovimientogestores( idempresa: string, tlicencia: string ) {
    let url = URL_SERVICIOS + '/movimiento/gestoresprecompra/' + idempresa +"/" + tlicencia;
    return this.http.get ( url )
    .map (( resp: any ) => {
       return (resp);
    });

  }


  muestralistadolotesprecompra( idempresa: string ) {
    let url = URL_SERVICIOS + '/movimiento/precompralote/' + idempresa;
    return this.http.get ( url )
    .map (( resp: any ) => {
       return (resp);
    });

  }




  listaentransito( idempresa: string ) {
    let url = URL_SERVICIOS + '/movimiento/entransito/' + idempresa;
    return this.http.get ( url )
    .map (( resp: any ) => {
       return (resp);
    });

  }

 
  listaentransitoagencias( idempresa: string, tlicencia: string ) {
    let url = URL_SERVICIOS + '/movimiento/entransitoagencias/' + idempresa + '/' + tlicencia;
    return this.http.get ( url )
    .map (( resp: any ) => {
       return (resp);
    });

  }









  getMuestraHistorial( nombrebarco : string , finicio: Date, ffin: Date, idempresa: string) {
      // console.log ('entro al sericio');
    const url = URL_SERVICIOS + '/movimientofilter/' + nombrebarco + '/' + finicio + '/' + ffin + '/' + idempresa;
    return this.http.get (url).map (( resp: any) => {
        return resp.movimiento;
    });
  }




}
